"use client";

// src/portal/portal-context.tsx
import { createContext } from "react";
var PortalContext = createContext(null);

export {
  PortalContext
};
